export const getProviders = (options) => {
  const { noLegacy } = options || {};
  return [
    {
      id: 'facebook',
      label: 'Facebook',
      color: '#3f5a98',
    },
    {
      id: 'twitter',
      label: 'Twitter',
      color: '#5fa8dc',
    },
    {
      id: 'google_oauth2',
      label: 'Google',
      color: '#4885ed',
    },
    {
      id: 'linkedin',
      label: 'LinkedIn',
      color: '#0077b5',
    },
    {
      id: 'instagram',
      overridedId: 'instagram_graph',
      label: 'Instagram',
      color: '#cd486b',
      legacy: true,
    },
    {
      id: 'email_campaign',
      label: 'Email Campaign',
      color: '#b6a058',
    },
    {
      id: 'anonymous_campaign',
      label: 'Anonymous Campaign',
      color: '#b6a058',
    },
    {
      id: 'text_campaign',
      label: 'Text Campaign',
      color: '#b6a058',
    },
  ].filter((item) => !noLegacy || !item.legacy);
};

/**
 * @see docs/worklog/maintenance/20093-investigate-facebook-auth-errors/rfc-frontend.md
 */
